// extracted by mini-css-extract-plugin
export var legendIndicator = "_bw-1";
export var legendRight = "_bw-0";